import { arbitrum, avalanche, base, bsc, mainnet, optimism, polygon } from 'viem/chains'
import type { AssetsConfigType } from './interfaces'
import { zeroAddress } from 'viem'
import { ARTXAI, CAI } from 'products'

export const dailySeconds = 86400
export const maxRangeDays = 60
export const pricesRefreshInterval = 300

export const assetConfig: AssetsConfigType = {
  assets: {
    //INFO: ==== DEFAULT ASSETS =====

    [`${avalanche.id}:${zeroAddress}`]: {
      //AVAX
      leastPossibleTimestamp: 1653350400,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${mainnet.id}:${zeroAddress}`]: {
      //ETH mainnet
      leastPossibleTimestamp: 1653350400,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${arbitrum.id}:${zeroAddress}`]: {
      //ETH arbitrum
      leastPossibleTimestamp: 1653350400,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${optimism.id}:${zeroAddress}`]: {
      //ETH optimism
      leastPossibleTimestamp: 1653350400,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${polygon.id}:${zeroAddress}`]: {
      //MATIC
      leastPossibleTimestamp: 1653350400,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:${zeroAddress}`]: {
      //ETH base
      leastPossibleTimestamp: 1653350400,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },

    //INFO: ==== MAINNET ASSETS ====
    [`${mainnet.id}:0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2`]: {
      //WETH
      leastPossibleTimestamp: 1653350400,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${mainnet.id}:0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48`]: {
      // USDC
      leastPossibleTimestamp: 1653350400,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${mainnet.id}:0xdac17f958d2ee523a2206206994597c13d831ec7`]: {
      // USDT
      leastPossibleTimestamp: 1653350400,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${mainnet.id}:0x6b175474e89094c44da98b954eedeac495271d0f`]: {
      // DAI
      leastPossibleTimestamp: 1653350400,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${mainnet.id}:0x0000000000085d4780b73119b644ae5ecd22b376`]: {
      // TUSD
      leastPossibleTimestamp: 1653350400,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${mainnet.id}:0xc5f0f7b66764f6ec8c8dff7ba683102295e16409`]: {
      // FDUSD
      leastPossibleTimestamp: 1653350400,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${mainnet.id}:0x4fabb145d64652a948d72533023f6e7a623c7c53`]: {
      // BUSD
      leastPossibleTimestamp: 1653350400,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${mainnet.id}:0x2260fac5e5542a773aa44fbcfedf7c193bc2c599`]: {
      // WBTC
      leastPossibleTimestamp: 1653350400,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },

    //INFO: ==== AVALANCHE ASSETS ====

    [`${avalanche.id}:${CAI.address}`]: {
      leastPossibleTimestamp: 1662076800,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },

    // //CAI assets
    [`${avalanche.id}:0xd1c3f94de7e5b45fa4edbba472491a9f4b166fc4`]: {
      //XAVA
      leastPossibleTimestamp: 1662076800,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${avalanche.id}:0x2b2c81e08f1af8835a78bb2a90ae924ace0ea4be`]: {
      //SAVAX
      leastPossibleTimestamp: 1662076800,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${avalanche.id}:0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7`]: {
      // WAVAX
      leastPossibleTimestamp: 1662076800,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${avalanche.id}:0x6e84a6216ea6dacc71ee8e6b0a5b7322eebc0fdd`]: {
      // JOE
      leastPossibleTimestamp: 1662076800,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${avalanche.id}:0x8729438eb15e2c8b576fcc6aecda6a148776c0f5`]: {
      // QI
      leastPossibleTimestamp: 1662076800,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${avalanche.id}:0x420fca0121dc28039145009570975747295f2329`]: {
      // COQ
      leastPossibleTimestamp: 1662076800,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${avalanche.id}:0xa25eaf2906fa1a3a13edac9b9657108af7b703e3`]: {
      // ggAVAX
      leastPossibleTimestamp: 1662076800,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${avalanche.id}:0x69260b9483f9871ca57f81a90d91e2f96c2cd11d`]: {
      // GGP
      leastPossibleTimestamp: 1662076800,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${avalanche.id}:0xec3492a2508ddf4fdc0cd76f31f340b30d1793e6`]: {
      // CLY
      leastPossibleTimestamp: 1662076800,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },

    //INFO ==== AVALANCHE EXTRA ====

    [`${avalanche.id}:0x5947bb275c521040051d82396192181b413227a3`]: {
      // LINK.e
      leastPossibleTimestamp: 1662076800,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${avalanche.id}:0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e`]: {
      // USDC
      leastPossibleTimestamp: 1662076800,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${avalanche.id}:0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7`]: {
      // USDt
      leastPossibleTimestamp: 1662076800,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${avalanche.id}:0xd586e7f844cea2f87f50152665bcbc2c279d8d70`]: {
      // DAI.e
      leastPossibleTimestamp: 1662076800,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${avalanche.id}:0x1c20e891bab6b1727d14da358fae2984ed9b59eb`]: {
      // TUSD
      leastPossibleTimestamp: 1662076800,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${avalanche.id}:0x9c9e5fd8bbc25984b178fdce6117defa39d2db39`]: {
      // BUSD
      leastPossibleTimestamp: 1662076800,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${avalanche.id}:0x408d4cd0adb7cebd1f1a1c33a0ba2098e1295bab`]: {
      // WBTC
      leastPossibleTimestamp: 1662076800,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${avalanche.id}:0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab`]: {
      // WETH.e
      leastPossibleTimestamp: 1662076800,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${avalanche.id}:0xf2f13f0b7008ab2fa4a2418f4ccc3684e49d20eb`]: {
      // WMATIC
      leastPossibleTimestamp: 1662076800,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    //INFO: ==== ARBITRUM ASSETS ====
    [`${arbitrum.id}:${ARTXAI.address}`]: {
      leastPossibleTimestamp: 1719792000,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },

    //INFO: TLS assets

    [`${arbitrum.id}:0x5979d7b546e38e414f7e9822514be443a4800529`]: {
      //wstETH
      leastPossibleTimestamp: 1716163200,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${arbitrum.id}:0x35751007a407ca6feffe80b3cb397736d2cf4dbe`]: {
      //weETH
      leastPossibleTimestamp: 1716163200,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${arbitrum.id}:0xec70dcb4a1efa46b8f2d97c310c9c4790ba5ffa8`]: {
      //rETH
      leastPossibleTimestamp: 1716163200,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${arbitrum.id}:0xd5f7838f5c461feff7fe49ea5ebaf7728bb0adfa`]: {
      //mETH+
      leastPossibleTimestamp: 1716163200,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${arbitrum.id}:0x2416092f143378750bb29b79ed961ab195cceea5`]: {
      //ezETH
      leastPossibleTimestamp: 1716163200,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    //HERE
    [`${arbitrum.id}:0xa6c895eb332e91c5b3d00b7baeeaae478cc502da`]: {
      //SY-WEETH
      leastPossibleTimestamp: 1715817600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${arbitrum.id}:0xf176fb51f4eb826136a54fdc71c50fcd2202e272`]: {
      //SY-RSETH
      leastPossibleTimestamp: 1715817600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${arbitrum.id}:0x0de802e3d6cc9145a150bbdc8da9f988a98c5202`]: {
      //SY-EZETH
      leastPossibleTimestamp: 1715817600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    //HERE
    // 'SY-WEETH': {
    //   leastPossibleTimestamp: 1717545600, //
    //   greatestPossibleTimestamp: 9999999999999,
    //   lastSyncTimestamp: 0,
    // },
    // 'SY-RSETH': {
    //   leastPossibleTimestamp: 1717545600, //
    //   greatestPossibleTimestamp: 9999999999999,
    //   lastSyncTimestamp: 0,
    // },
    // 'SY-EZETH': {
    //   leastPossibleTimestamp: 1717545600, //
    //   greatestPossibleTimestamp: 9999999999999,
    //   lastSyncTimestamp: 0,
    // },
    // '0x0de802e3d6cc9145a150bbdc8da9f988a98c5202': { icon: ezETH, symbol: 'ezETH' }, //SY-ezETH
    [`${arbitrum.id}:0x4186bfc76e2e237523cbc30fd220fe055156b41f`]: {
      //rsETH
      leastPossibleTimestamp: 1715817600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${arbitrum.id}:0x1debd73e752beaf79865fd6446b0c970eae7732f`]: {
      //cbETH
      leastPossibleTimestamp: 1715817600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${arbitrum.id}:0x95ab45875cffdba1e5f451b950bc2e42c0053f39`]: {
      //sfrxETH
      leastPossibleTimestamp: 1715817600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${arbitrum.id}:0xe6c8d111337d0052b9d88bf5d7d55b7f8385acd3`]: {
      //ETHx +
      leastPossibleTimestamp: 1715817600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },

    //INFO: ARTXAI assets
    [`${arbitrum.id}:0xaf88d065e77c8cc2239327c5edb3a432268e5831`]: {
      //USDC
      leastPossibleTimestamp: 1716336000,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${arbitrum.id}:0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f`]: {
      //WBTC
      leastPossibleTimestamp: 1716336000,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },

    //INFO ==== ARBITRUM EXTRA ====

    [`${arbitrum.id}:0x912ce59144191c1204e64559fe8253a0e49e6548`]: {
      //ARB
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${arbitrum.id}:0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9`]: {
      //USDT
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${arbitrum.id}:0xda10009cbd5d07dd0cecc66161fc93d7c9000da1`]: {
      //DAI
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${arbitrum.id}:0x4d15a3a2286d883af0aa1b3f21367843fac63e07`]: {
      //TUSD
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${arbitrum.id}:0x82af49447d8a07e3bd95bd0d56f35241523fbab1`]: {
      //WETH
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${arbitrum.id}:0x371c7ec6d8039ff7933a2aa28eb827ffe1f52f07`]: {
      //JOE
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${arbitrum.id}:0xff970a61a04b1ca14834a43f5de4533ebddb5cc8`]: {
      //USDC.e
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },

    //INFO: ==== POLYGON ASSETS ====
    [`${polygon.id}:0xfa68fb4628dff1028cfec22b4162fccd0d45efb6`]: {
      //MATICX
      leastPossibleTimestamp: 1715817600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${polygon.id}:0x3a58a54c066fdc0f2d55fc9c89f0415c92ebf3c4`]: {
      //STMATIC
      leastPossibleTimestamp: 1716163200,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    //===
    [`${polygon.id}:0x53e0bca35ec356bd5dddfebbd1fc0fd03fabad39`]: {
      //LINK
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${polygon.id}:0x2791bca1f2de4661ed88a30c99a7a9449aa84174`]: {
      //USDC.e
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${polygon.id}:0xc2132d05d31c914a87c6611c10748aeb04b58e8f`]: {
      //USDT
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${polygon.id}:0x8f3cf7ad23cd3cadbd9735aff958023239c6a063`]: {
      //DAI
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${polygon.id}:0x9c9e5fd8bbc25984b178fdce6117defa39d2db39`]: {
      //BUSD
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${polygon.id}:0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6`]: {
      //WBTC
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${polygon.id}:0x7ceb23fd6bc0add59e62ac25578270cff1b9f619`]: {
      //WETH
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${polygon.id}:0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270`]: {
      //WMATIC
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${polygon.id}:0x03b54a6e9a984069379fae1a4fc4dbae93b3bccd`]: {
      //wstETH
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${polygon.id}:0x4b4327db1600b8b1440163f667e199cef35385f5`]: {
      //fxcbETH
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${polygon.id}:0x6d1fdbb266fcc09a16a22016369210a15bb95761`]: {
      //sfrxETH
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },

    //INFO: ==== OPTIMISM ASSETS ====
    [`${optimism.id}:0x4200000000000000000000000000000000000042`]: {
      //OP
      leastPossibleTimestamp: 1715817600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    //===
    [`${optimism.id}:0x350a791bfc2c21f9ed5d10980dad2e2638ffa7f6`]: {
      //LINK
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${optimism.id}:0x0b2c639c533813f4aa9d7837caf62653d097ff85`]: {
      //USDC
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${optimism.id}:0x94b008aa00579c1307b0ef2c499ad98a8ce58e58`]: {
      //USDT
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${optimism.id}:0xda10009cbd5d07dd0cecc66161fc93d7c9000da1`]: {
      //DAI
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${optimism.id}:0x68f180fcce6836688e9084f035309e29bf0a2095`]: {
      //WBTC
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${optimism.id}:0x4200000000000000000000000000000000000006`]: {
      //WETH
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${optimism.id}:0x1f32b1c2345538c0c6f582fcb022739c4a194ebb`]: {
      //wstETH
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${optimism.id}:0x9bcef72be871e61ed4fbbc7630889bee758eb81d`]: {
      //rETH
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${optimism.id}:0xaddb6a0412de1ba0f936dcaeb8aaa24578dcf3b2`]: {
      //cbETH
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${optimism.id}:0x484c2d6e3cdd945a8b2df735e079178c1036578c`]: {
      //sfrxETH
      leastPossibleTimestamp: 1717545600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },

    //INFO: BASE ASSETS
    [`${base.id}:0x1c4cca7c5db003824208adda61bd749e55f463a3`]: {
      //GAME
      leastPossibleTimestamp: 1737504000,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0xc0041ef357b183448b235a8ea73ce4e4ec8c265f`]: {
      //COOKIE
      leastPossibleTimestamp: 1737504000,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x55cd6469f597452b5a7536e2cd98fde4c1247ee4`]: {
      //LUNA
      leastPossibleTimestamp: 1737504000,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x731814e491571a2e9ee3c5b1f7f3b962ee8f4870`]: {
      //VADER
      leastPossibleTimestamp: 1737504000,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0xac1bd2486aaf3b5c0fc3fd868558b082a531b2b4`]: {
      //TOSHI
      leastPossibleTimestamp: 1737504000,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x0b3e328455c4059eeb9e3f84b5543f74e24e7e1b`]: {
      //VIRTUAL
      leastPossibleTimestamp: 1737504000,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x4f9fd6be4a90f2620860d680c0d4d5fb53d1a825`]: {
      //AIXBT
      leastPossibleTimestamp: 1737504000,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x6b2504a03ca4d43d0d73776f6ad46dab2f2a4cfd`]: {
      //REI
      leastPossibleTimestamp: 1737504000,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0xb89d354ad1b0d95a48b3de4607f75a8cd710c1ba`]: {
      //LAY
      leastPossibleTimestamp: 1737504000,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x1bc0c42215582d5a085795f4badbac3ff36d1bcb`]: {
      //CLANKER
      leastPossibleTimestamp: 1737504000,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x1185cb5122edad199bdbc0cbd7a0457e448f23c7`]: {
      //SEKOIA
      leastPossibleTimestamp: 1737504000,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x76c71f1703fbf19ffdcf3051e1e684cb9934510f`]: {
      //AIXCB
      leastPossibleTimestamp: 1737504000,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x532f27101965dd16442e59d40670faf5ebb142e4`]: {
      //BRETT
      leastPossibleTimestamp: 1723075200,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x57f5fbd3de65dfc0bd3630f732969e5fb97e6d37`]: {
      //TRUMP
      leastPossibleTimestamp: 1723075200,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x2da56acb9ea78330f947bd57c54119debda7af71`]: {
      //Mog
      leastPossibleTimestamp: 1723075200,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x61a287fc37559c71ba7cf6c35f3a5716dc91d265`]: {
      //pwMog(old)
      leastPossibleTimestamp: 1723075200,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x66af6b21aad17849bf8db8844b26d5cdd1b7ac86`]: {
      //pwMog(new)
      leastPossibleTimestamp: 1723075200,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0xeff13712b5efacf5213f9a76bc58d89f037d71d3`]: {
      //pwMog(new)
      leastPossibleTimestamp: 1723075200,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    //INFO: BSC ASSETS
    [`${bsc.id}:0xba2ae424d960c26247dd6c32edc70b295c744c43`]: {
      //DOGE
      leastPossibleTimestamp: 1723075200,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${bsc.id}:0xa697e272a73744b343528c3bc4702f2565b2f422`]: {
      //BONK
      leastPossibleTimestamp: 1723075200,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${bsc.id}:0xfb5b838b6cfeedc2873ab27866079ac55363d37e`]: {
      //FLOKI
      leastPossibleTimestamp: 1723075200,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },

    // INFO: JMX ASSETS
    [`${base.id}:${'0x83190636c344Cf1220ffcBFc0C1198f7867b3667'.toLowerCase()}`]: {
      //JMX prod
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    //base assets
    [`${base.id}:0x1fba65de0a9cbd2d1df82d141897042d36bb6c86`]: {
      //WIF
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x50da645f148798f68ef2d7db7c1cb22a6819bb2c`]: {
      //SPX
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0xb1a03eda10342529bbf8eb700a06c60441fef25d`]: {
      //MIGGLES
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0xbc45647ea894030a4e9801ec03479739fa2485f0`]: {
      //BENJI
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x4ed4e862860bed51a9570b96d89af5e1b0efefed`]: {
      //DEGEN
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x768be13e1680b5ebe0024c42c896e3db59ec0149`]: {
      //SKI
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    // INFO: based assets
    [`${base.id}:0x1fb8432d5e243986df8ab85aea1dff5030ac54b6`]: {
      //bCOQ
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x87eedc11abe771273246172a4a922dea68796c2d`]: {
      //bTRUMP
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x7f3b6f46503a7fe22cbed587d94b5566c99a3f07`]: {
      //bMEME
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x1666fe591e2f378091c7a9866d80da445fd3a1f3`]: {
      //bNeiro
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0xfdccd3180eb9fdc0fbac08d5a59b628c978f0fe8`]: {
      //bBONK
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x2f225080c88934b211ef41f1247a88f6a1c30db6`]: {
      //bFLOKI
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0xc847511c793202c4ef86ae006d81baceeed8ff5c`]: {
      //bBabyDoge
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x2943191025ae254a7546bddc57e6173826e4dbc7`]: {
      //bDOGE
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x638bdc76db8aacc2cae4a4302334007ca300d4c9`]: {
      //bSHIB
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0xfdb933367b116f31b24116e761234e631092b7f2`]: {
      //bPEPE
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0xc803a27157b69f3eeafc3ff6af77b40e9d79274c`]: {
      //bELON
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x100ce3e3391c00b6a52911313a4ea8d23c8a38d8`]: {
      //JOOCE
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x7510f51a66ce78c9932056b17c26bbbe9f56336d`]: {
      //CAT
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x9a26f5433671751c3276a065f57e5a02d2817973`]: {
      //KEYCAT
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
    [`${base.id}:0x6921b130d297cc43754afba22e5eac0fbf8db75b`]: {
      //DOGINME
      leastPossibleTimestamp: 1738281600,
      greatestPossibleTimestamp: 9999999999999,
      lastSyncTimestamp: 0,
    },
  },
  maximumAllowedRangeDays: maxRangeDays,
  refreshTimeIntervalGranularity: dailySeconds,
  maximumAllowedTimeRange: dailySeconds * maxRangeDays,
  maximumRequestableRangeBatches: 30,
  maximumRequestableAssets: 20,
}
